import Immutable from 'seamless-immutable';

import {
  TOGGLE_NAVBAR,
  OPEN_NAVBAR,
  CLOSE_NAVBAR
} from '../Actions/Navigation';

const initialState = Immutable({
  collapsedNavbar: true
});

export default function NavigationReducer(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_NAVBAR:
      return Immutable.merge(state, {
        collapsedNavbar: !state.collapsedNavbar
      });
    case OPEN_NAVBAR:
      return Immutable.merge(state, {
        collapsedNavbar: false
      });
    case CLOSE_NAVBAR:
      return Immutable.merge(state, {
        collapsedNavbar: true
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/NavigationReducer.js